import { useEffect, useState } from 'react';
import useApiMethods from '../../lib/useApiMethods';


/**
 * Fetches the engage procedure catalog once and exposes:
 *   - `list`         : all catalog entries
 *   - `byNameLower`  : lookup {name.toLowerCase(): entry}
 *   - `findByName`   : (name) => entry or undefined (case-insensitive)
 */
export default function useProcedureCatalog() {
  const { fetch: apiFetch } = useApiMethods();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const resp = await apiFetch('engage/analytics/procedure-catalog/');
        const rows = resp?.data || resp?.data?.data || [];
        if (!cancelled) setList(Array.isArray(rows) ? rows : []);
      } catch {
        if (!cancelled) setList([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const byNameLower = list.reduce((acc, r) => {
    acc[(r.name || '').trim().toLowerCase()] = r;
    return acc;
  }, {});
  const findByName = (name) => byNameLower[(name || '').trim().toLowerCase()];

  return { list, byNameLower, findByName, loading };
}
